var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chemical-isotope',_vm._g(_vm._b({style:(_vm.style),attrs:{"symbol":_vm.symbol}},'chemical-isotope',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }